import { render, staticRenderFns } from "./ZoomSlider.vue?vue&type=template&id=1a7b3dea&scoped=true&"
import script from "./ZoomSlider.vue?vue&type=script&lang=js&"
export * from "./ZoomSlider.vue?vue&type=script&lang=js&"
import style0 from "./ZoomSlider.vue?vue&type=style&index=0&id=1a7b3dea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b3dea",
  null
  
)

export default component.exports